import store from '../store';
import {GET_BOOKING, GET_BOOKING_DISCOUNT, GET_FLEX_EXTRA_SELECTED} from '../store/booking/getter-types';
import { GET_RESERVATION_ID, NIGHTS_GET_IS_PACK_FLIGHT, NIGHTS_GET_NIGHTS } from '../store/nights/getter-types';

const prepareReservation = data => {
  const booking = store.getters[GET_BOOKING];

  return {
    booking_token: booking.bookingToken,
    origin_code: booking.outgoingFlight.departure.airport,
    destination_code: booking.outgoingFlight.arrival.airport,
    outbound_departure_time: booking.outgoingFlight.departure.datetime,
    outbound_departure_airport: booking.outgoingFlight.departure.airport,
    outbound_arrival_time: booking.outgoingFlight.arrival.datetime,
    outbound_arrival_airport: booking.outgoingFlight.arrival.airport,
    inbound_departure_time: booking.returnFlight.departure.datetime,
    inbound_departure_airport: booking.returnFlight.departure.airport,
    inbound_arrival_time: booking.returnFlight.arrival.datetime,
    inbound_arrival_airport: booking.returnFlight.arrival.airport,
    discount_code: store.getters[GET_BOOKING_DISCOUNT] ? booking.discountCode.code_name : null,
    airline: window.app._route.query.airlines,
    flight_price_per_passenger: booking.travellerPrice,
    accommodation_id: booking.accomodation.selected && booking.accomodation.selected || 1,
    newsletter: booking.terms.promotions.value,
    comments: booking.comments,
    nights: false,
    extras: booking.extras.available.filter(extra => (extra.hasCounter == 1 && extra.quantity > 0 && extra.selected) || (extra.hasCounter == 0 && extra.selected)),
    passengers: preparePassengers(booking.travellers),
    flex_extra: store.getters[GET_FLEX_EXTRA_SELECTED] || null
  };
};

const prepareChoice = type => {
  switch (type) {
    case 'bonus':
      return prepareBonus();
    case 'gift':
      return prepareGifts();
    case 'nights':
      return prepareNightsReservation();
    case 'default':
      return prepareReservation();
  }
};

const prepareGifts = data =>{
    return { ...store.state.gifts, locations: null };
}

const prepareNightsReservation = () => {
  const data = store.state.nights;
  return {
    "booking_token": data.flight.bookingToken,
    "origin_code": data.origin.code,
    "destination_code": data.destination.code,
    "flightId": data.flight.id,
    "outbound_departure_time": data.flight.journeyFlightDepartureTime.toISOString(),
    "outbound_departure_airport": data.flight.airportFrom,
    "outbound_arrival_time": data.flight.journeyFlightArrivalTime.toISOString(),
    outbound_arrival_airport: data.flight.airportTo,
    "inbound_departure_time": data.flight.returnFlightDepartureTime.toISOString(),
    inbound_departure_airport: data.flight.airportTo,
    "inbound_arrival_time": data.flight.returnFlightArrivalTime.toISOString(),
    inbound_arrival_airport: data.flight.airportFrom,
    "flight_price_per_passenger": data.flight.price,
    "hotelbedsRooms": ! _.isEmpty(data.hotel) ? data.hotel.rooms : null,
    "hotelAddress": data.hotel ? data.hotel.address : null,
    "hotelImage": data.hotel ? data.hotel.image : null,
    "hotelDistance": data.hotel ? data.hotel.distance : null,
    "hotelCategory": data.hotel ? data.hotel.category : null,
    "journeyStopOvers": data.flight.journeyStopOvers ? data.flight.journeyStopOvers : null,
    "returnStopOvers": data.flight.returnStopOvers ? data.flight.returnStopOvers : null,
    "hotel_pack": data.selectedCategory?.name,
    "extras": data.extras,
    "passengers": data.passengers,
    "nightsCount": store.getters[NIGHTS_GET_NIGHTS],
    "nights": true,
    "discount_code": store.state.nights.discountCode ? store.state.nights.discountCode.code_name : null,
    "newsletter": data.newsletter,
    "comments": "",
    "contact": data.contact,
    "itinerary": store.state.nights.itinerary,
    "pack_contact": data.packAvmContact,
    "reservation_code": store.getters[GET_RESERVATION_ID],
    "flex_extra": store.getters[GET_FLEX_EXTRA_SELECTED] || null,
    "is_pack_flight": store.getters[NIGHTS_GET_IS_PACK_FLIGHT],
    "bundle_pack": store.getters['tripPrice']
  }
}

const prepareBonus = () => {
  return {
    "reserve": {...store.state.reservationReserve},
    "passengers": store.state.newPassengers,
    "extras": store.state.newExtras
  }
}


const preparePassengers = (travellers) => {
  let passengers = [];

  let adults = travellers.adults.data.length > 0 && travellers.adults.data.map(adult => {
      return {
            name: adult.name,
            last_name: adult.lastName,
            email: adult.email,
            date_of_birth: adult.date_of_birth ? adult.date_of_birth : '',
            expiration_date: adult.expiration_date ? adult.expiration_date : '',
            card_id_type: adult.card_id_type ? adult.card_id_type : '',
            card_id: adult.card_id ? adult.card_id : '',
            phone_prefix: adult.phone_prefix ? adult.phone_prefix : '',
            phone: adult.phone ? adult.phone : '',
            type: adult.type,
            gender: adult.gender,
            nationality: adult.nationality
        }
  })

  let childs = travellers.childs.data.length > 0 && travellers.childs.data.map(child => {
      return {
            name: child.name,
            last_name: child.lastName,
            email: child.email,
            date_of_birth: child.date_of_birth ? child.date_of_birth : '',
            expiration_date: child.expiration_date ? child.expiration_date : '',
            card_id_type: child.card_id_type ? child.card_id_type : 'dni',
            card_id: child.card_id ? child.card_id : '',
            phone_prefix: child.phone_prefix ? child.phone_prefix : '',
            phone: child.phone_prefix ? child.phone_prefix : '',
            type: 'child',
            gender: child.gender,
            nationality: child.nationality
        }
  }) || []

  let babies = travellers.babies.data.length > 0 && travellers.babies.data.map(baby => {
      return {
            name: baby.name,
            last_name: baby.lastName,
            email: baby.email,
            date_of_birth: baby.date_of_birth ? baby.date_of_birth : '',
            expiration_date: baby.expiration_date ? baby.expiration_date : '',
            card_id_type: baby.card_id_type ? baby.card_id_type : 'dni',
            card_id: baby.card_id ? baby.card_id : '',
            phone_prefix: baby.phone_prefix ? baby.phone_prefix : '',
            phone: baby.phone_prefix ? baby.phone_prefix : '',
            type: 'baby',
            gender: baby.gender,
            nationality: baby.nationality
        }
  }) || []
  passengers = adults.concat(childs, babies)
  return passengers;
}


export default prepareChoice;
